// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1142":"03283e48","5345":"09a83c2e","6951":"af9844a4"}[chunkId] + ".chunk.css";
};